import { AnalyticsTypes } from '../../middleware/google-analytics';

export const createGaActionCreator = (actionType, category, action) => ({
    type: actionType,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category,
            action,
        },
    },
});

export const createGaActionCreatorWithLabel = (
    actionType,
    category,
    action,
    label
) => ({
    type: actionType,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category,
            action,
            data: {
                Label: label,
            },
        },
    },
});

export const createGaActionCreatorWithDetails = (
    actionType,
    category,
    action,
    eventDetails
) => ({
    type: actionType,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category,
            action,
            eventDetails,
        },
    },
});
